export const userColumns = [
    {
      field:"copuanTitle",
      headerName:"Coupon Title",
      width:"150"
    },
    {
      field:"discount_percentage",
      headerName:"Discount Percentage",
      width:"150"
    },
    {
      field:"discount_amount",
      headerName:"Discount Amount",
      width:"150"
    },
    {
      field:"copuanCode",
      headerName:"Copuon Code",
      width:"150"
    },
    {
      field:"createdAt",
      headerName:"Create At",
      width:"250"
    },
    {
      field:"expireAt",
      headerName:"Expire At",
      width:"250"
    },
]